import { PAGEAMOUNT_DEFAULT, PAGINATION_TYPE } from '../../../@shared/constants';

export interface ErrorResponse {
    error: {
        errors: string[];
        isEmpty: boolean;
    };
}
export class PaginationRequest {
    Page?: number = 0;
    Amount?: number = PAGEAMOUNT_DEFAULT;
    Sort?: string = '';
    SearchText?: string = '';
    PaginationType?: number = PAGINATION_TYPE.ALL;
    ByPassBranch?: boolean;
    IsConsignmentSearch?: boolean;
}

export interface PaginationResponse<T> {
    page: number;
    data: T[];
    amount: number;
    totalPage: number;
    sort: string;
    searchText: string;
    totalCount: number;
}
